import ServiceApi from '../services/service.api';

const baseServiceUrl = `/referrers`;

type BasePostReferralBody = {
  appt_id: number;
  hospital_id?: number;
  postcode?: string;
  refclin_guid?: string;
  specarea?: string;
  speccat: string;
  urg_code?: string;
  user_guid: string;
};

const ApiReferrer = {
  AddMember: (input: any) => {
    const url = `${baseServiceUrl}/member`;

    const body = {
      ...input,
      user_guid: ServiceApi.userGuid
    };

    return ServiceApi.put(url, body);
  },
  getTriage: (params: any) => {
    const url = `${baseServiceUrl}/triage`;
    return new Promise((resolve, reject) => {
      ServiceApi.post(url, params)
        .then((res: any) => {
          resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  },
  search: (params: any) => {
    const url = `${baseServiceUrl}/patients/${ServiceApi.userGuid}`;
    return new Promise((resolve, reject) => {
      ServiceApi.get(url, { params })
        .then((res: any) => {
          resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  },
  checkMemberExist: (email: any) => {
    const url = `${baseServiceUrl}/email/${ServiceApi.userGuid}`;
    const params = { email };
    return ServiceApi.get(url, { params }); //200 exist, 404 not exist
  },
  member_editProfile: (params: any) => {
    const url = `${baseServiceUrl}/member/profile`;
    const body = { user_guid: ServiceApi.userGuid, ...params };
    console.debug('EDIT MEMBER PRE-BODY', body);
    return ServiceApi.post(url, body);
  },
  resendInvitationEmail: (target_guid: any) => {
    const url = `${baseServiceUrl}/welcome/resend`;
    const body = {
      user_guid: ServiceApi.userGuid,
      resend_user_guid: target_guid
    };
    console.debug('RESEND INVITATION EMAIL PRE-BODY', body);
    return ServiceApi.put(url, body);
  },
  resendInvitationEmailNew: (guid: any) => {
    const url = `/resend-welcome?up_user_guid=${guid}`;
    return ServiceApi.get(url);
  },
  getAppointmentReferral: (params: any) => {
    const url = `${baseServiceUrl}/case/refer/${ServiceApi.userGuid}`;
    return ServiceApi.get(url, { params });
  },
  postReferral: (
    postBody:
      | (BasePostReferralBody & {
          /** A reason for referral code, as defined in `GET` `v1/meta/appointments` */
          ref_reason_code: string;
          ca_creating?: 0 | 1;
        })
      | (BasePostReferralBody & {
          /** Free text reason for referral */
          reason: string;
          ca_creating?: 0 | 1;
        })
  ) => {
    return ServiceApi.post(`${baseServiceUrl}/case/refer`, postBody);
  },
  getPatientInfo: (params: any) => {
    const url = `${baseServiceUrl}/patients/${ServiceApi.userGuid}`;
    return ServiceApi.get(url, { params });
  },
  postAppointmentReferral: (params: any) => {
    const url = `${baseServiceUrl}/case/refer/`;
    const body = {
      user_guid: ServiceApi.userGuid,
      ...params
    };
    console.debug('post AppointmentRef PRE-BODY', body);
    return ServiceApi.post(url, body);
  },
  rejectReferral: (body: any) => {
    const url = `${baseServiceUrl}/case/refer/reject`;
    const params = { user_guid: ServiceApi.userGuid, ...body };
    return ServiceApi.post(url, params);
  },
  updateApptUbrn: (appt_id: any, ubrn: any) => {
    const url = `${baseServiceUrl}/appointment/ubrn`;
    const params = {
      user_guid: ServiceApi.userGuid,
      appt_id,
      ubrn
    };
    return ServiceApi.post(url, params);
  },
  checkUbrn: (ubrn: any, case_id: any) => {
    // basic validation on ubrns
    // returns 200 with ubrn on success
    // returns 404 without on failure
    const url = `/ers/referral/check?ubrn=${ubrn}&case_id=${case_id}&user_guid=${ServiceApi.userGuid}`;
    const params = {
      ubrn,
      case_id
    };
    return ServiceApi.get(url, params);
  }
};

export default ApiReferrer;
